import { all, fork } from "redux-saga/effects";

import {
  compactSchoolsSagaWatcher,
  extendedSchoolsSagaWatcher,
  adminAllSchoolsSagaWatcher,
  adminPendingSchoolsSagaWatcher,
  singleSchoolSagaWatcher,
  moveSchoolToNewProfileSagaWatcher,
  currentAdminSchoolSagaWatcher,
  createSchoolSagaWatcher,
  editSchoolSagaWatcher,
  actionSchoolSagaWatcher,
  setSchoolDistributionReportSagaWatcher,
  distributionReportSchoolSagaWatcher,
  schoolsForCsvTemplateSagaWatcher,
} from "data-handler/ducks/schools";

import {
  commoditySourcesForSchoolSagaWatcher,
  commoditySourcesForUserSagaWatcher,
  allCommoditySourcesSagaWatcher,
} from "data-handler/ducks/schools2";

import { analyticsSagaWatcher } from "data-handler/ducks/analytics";
import { foodSourcesSagaWatcher } from "data-handler/ducks/foodSources";
import { noMealReasonsSagaWatcher } from "data-handler/ducks/noMealReasons";
import { featureFlagsSagaWatcher } from "data-handler/ducks/featureFlags";

import commodities from "data-handler/ducks/commodities";
import { regionsDuck } from "data-handler/ducks/regions";
import {
  detailedStockDataSagaWatcher,
  storeDoctorDataSagaWatcher,
  stockMigrationSagaWatcher,
  storeDoctorExportSagaWatcher,
  eventsExportSagaWatcher,
} from "data-handler/ducks/storeDoctor";
import {
  storesSaga,
  updateStoreSagaWatcher,
  userStoresSagaWatcher,
  userSchoolIdsSagaWatcher,
  asyncSyncWatcher,
  checkPendingSyncsWatcher,
} from "data-handler/ducks/stores";
import { loginSagaWatcher, logoutSagaWatcher } from "data-handler/ducks/auth";
import {
  usersSagaWatcher,
  countryAdminPendingUsersSagaWatcher,
  countryAdminAllUsersSagaWatcher,
  countryAdminActionUserSagaWatcher,
  countryAdminAppoversSagaWatcher,
  countryAdminSchoolGroupAdminSagaWatcher,
  currentUserSagaWatcher,
  editUserSagaWatcher,
} from "data-handler/ducks/users";
import {
  countryAdminSchoolProfilesSagaWatcher,
  countryAdminDetailedSchoolProfileSagaWatcher,
  countryAdminPostDetailedSchoolProfileSagaWatcher,
  countryAdminPostNewSchoolProfileSagaWatcher,
  countryAdminDeleteSchoolProfileSagaWatcher,
  countryAdminSchoolProfilesNonPaginatedSagaWatcher,
} from "data-handler/ducks/schoolProfile";
import incidentCausesDuck from "data-handler/ducks/incidentCauses";
import deliveryIssuesDuck from "data-handler/ducks/deliveryIssues";
import distributionSitesDuck from "data-handler/ducks/distributionSites";
import { batchNumbersSagaWatcher } from "data-handler/ducks/batchNumbers";
import {
  downloadDatasetSagaWatcher,
  downloadDatasetsSagaWatcher,
} from "./ducks/datasets";
import {
  distributionReportsNonPaginatedSagaWatcher,
  partnershipsSagaWatcher,
  locationsSagaWatcher,
  allDistributionReportsSagaWatcher,
  locationsSagaActivityCodesWatcher,
  beneficiaryGroupsSagaWatcher,
  createDistributionReportSagaWatcher,
  editDistributionReportSagaWatcher,
  organizationUnitsSagaWatcher,
  currentDistributionReportSagaWatcher,
} from "data-handler/ducks/distributionReports";
import {
  getCountryAdminRolesSagaWatcher,
  postCountryAdminRolesSagaWatcher,
  getCountryAdminRoleMappingSagaWatcher,
} from "data-handler/ducks/roles";
import reportsDuck, {
  recalculateWatcher as reportsRecalculateWatcher,
} from "data-handler/ducks/reports";
import reportsV3Duck, {
  recalculateWatcher as reportsV3RecalculateWatcher,
} from "data-handler/ducks/reportsV3";
import { countriesDuck } from "data-handler/ducks/countries";
import { registrationSaga } from "data-handler/ducks/registration";
import {
  requestCountryAuthorityTypesSagaWatcher,
  requestEducationAuthoritiesSagaWatcher,
} from "data-handler/ducks/authorityLevels";
import {
  requestCountryAdminLevelsSagaWatcher,
  requestSchoolAdminsSagaWatcher,
  requestUpdateCountryAdminLevelsSagaWatcher,
  requestRegistrationSchoolsSagaWatcher,
} from "data-handler/ducks/adminLevels";

import {
  cometAgeGroupsSagaWatcher,
  levelAgeGroupsSagaWatcher,
  updateLevelMappingsSagaWatcher,
} from "./ducks/ageGroups";
import {
  importCsvFileSagaWatcher,
  downloadCsvTemplateSagaWatcher,
  requestSchoolsImportsSagaWatcher,
  requestCurrentSchoolsImportSagaWatcher,
  requestSchoolsImportRecordsSagaWatcher,
} from "data-handler/ducks/schoolsImports";
import { changeLanguageWatcher } from "data-handler/ducks/language";
import { getLinksSagaWatcher } from "data-handler/ducks/links";
import { privacyStatementSagaWatcher } from "data-handler/ducks/statements";
import { termsStatementSagaWatcher } from "data-handler/ducks/statements";
import {
  vendorCategoriesSagaWatcher,
  adminVendorsSagaWatcher,
  performVendorActionSagaWatcher,
  allApprovedVendorsSagaWatcher,
  createVendorSagaWatcher,
  currentAdminVendorSagaWatcher,
  editVendorSagaWatcher,
  pendingAdminVendorsSagaWatcher,
  vendorsImportsSagaWatcher,
  importVendorCsvFileSagaWatcher,
  downloadVendorCsvTemplateSagaWatcher,
  requestCurrentVendorsImportSagaWatcher,
  requestVendorsImportRecordsSagaWatcher,
  vendorsForCsvTemplateSagaWatcher,
} from "./ducks/vendors";
import { purchaseOtherCostsSagaWatcher } from "./ducks/purchaseOtherCosts";
import { stockInspectSagaWatcher } from "./ducks/stockInspect";
import { stockSiblingsSagaWatcher } from "./ducks/stockSiblings";
import { mvRefreshLogSagaWatcher } from "./ducks/mvRefreshLog";
import { batchHealSagaWatcher } from "./ducks/batchHeal";
import { xraySagaWatcher } from "./ducks/xray";
import {
  needsReviewListSagaWatcher,
  needsReviewResolveSagaWatcher,
  needsReviewCountSagaWatcher,
  needsReviewImpactSagaWatcher,
  needsReviewApplySagaWatcher,
} from "./ducks/needsReview";

export default function* rootSaga() {
  yield all([
    fork(analyticsSagaWatcher),
    fork(actionSchoolSagaWatcher),
    fork(adminAllSchoolsSagaWatcher),
    fork(adminPendingSchoolsSagaWatcher),
    fork(allDistributionReportsSagaWatcher),
    fork(compactSchoolsSagaWatcher),
    fork(extendedSchoolsSagaWatcher),
    fork(batchNumbersSagaWatcher),
    fork(beneficiaryGroupsSagaWatcher),
    fork(changeLanguageWatcher),
    fork(cometAgeGroupsSagaWatcher),
    fork(commodities._detailWatcher),
    fork(commodities._listWatcher),
    fork(countriesDuck._detailWatcher),
    fork(countriesDuck._listWatcher),
    fork(countryAdminActionUserSagaWatcher),
    fork(countryAdminAllUsersSagaWatcher),
    fork(countryAdminAppoversSagaWatcher),
    fork(countryAdminSchoolGroupAdminSagaWatcher),
    fork(countryAdminDeleteSchoolProfileSagaWatcher),
    fork(countryAdminDetailedSchoolProfileSagaWatcher),
    fork(countryAdminPendingUsersSagaWatcher),
    fork(countryAdminPostDetailedSchoolProfileSagaWatcher),
    fork(countryAdminPostNewSchoolProfileSagaWatcher),
    fork(countryAdminSchoolProfilesNonPaginatedSagaWatcher),
    fork(countryAdminSchoolProfilesSagaWatcher),
    fork(createDistributionReportSagaWatcher),
    fork(createSchoolSagaWatcher),
    fork(currentAdminSchoolSagaWatcher),
    fork(currentDistributionReportSagaWatcher),
    fork(currentUserSagaWatcher),
    fork(deliveryIssuesDuck._detailWatcher),
    fork(deliveryIssuesDuck._listWatcher),
    fork(distributionReportSchoolSagaWatcher),
    fork(distributionReportsNonPaginatedSagaWatcher),
    fork(distributionReportsNonPaginatedSagaWatcher),
    fork(distributionSitesDuck._detailWatcher),
    fork(distributionSitesDuck._listWatcher),
    fork(downloadCsvTemplateSagaWatcher),
    fork(editDistributionReportSagaWatcher),
    fork(editSchoolSagaWatcher),
    fork(editUserSagaWatcher),
    fork(getCountryAdminRoleMappingSagaWatcher),
    fork(getCountryAdminRolesSagaWatcher),
    fork(getLinksSagaWatcher),
    fork(importCsvFileSagaWatcher),
    fork(incidentCausesDuck._detailWatcher),
    fork(incidentCausesDuck._listWatcher),
    fork(levelAgeGroupsSagaWatcher),
    fork(locationsSagaActivityCodesWatcher),
    fork(locationsSagaWatcher),
    fork(locationsSagaWatcher),
    fork(loginSagaWatcher),
    fork(logoutSagaWatcher),
    fork(moveSchoolToNewProfileSagaWatcher),
    fork(organizationUnitsSagaWatcher),
    fork(partnershipsSagaWatcher),
    fork(partnershipsSagaWatcher),
    fork(postCountryAdminRolesSagaWatcher),
    fork(regionsDuck._detailWatcher),
    fork(regionsDuck._listWatcher),
    fork(registrationSaga),
    fork(reportsDuck._detailWatcher),
    fork(reportsDuck._listWatcher),
    fork(reportsRecalculateWatcher),
    fork(reportsV3Duck._detailWatcher),
    fork(reportsV3Duck._listWatcher),
    fork(reportsV3RecalculateWatcher),
    fork(requestCountryAdminLevelsSagaWatcher),
    fork(requestCountryAuthorityTypesSagaWatcher),
    fork(requestCurrentSchoolsImportSagaWatcher),
    fork(requestEducationAuthoritiesSagaWatcher),
    fork(requestRegistrationSchoolsSagaWatcher),
    fork(requestSchoolAdminsSagaWatcher),
    fork(requestSchoolsImportRecordsSagaWatcher),
    fork(requestSchoolsImportsSagaWatcher),
    fork(requestUpdateCountryAdminLevelsSagaWatcher),
    fork(schoolsForCsvTemplateSagaWatcher),
    fork(setSchoolDistributionReportSagaWatcher),
    fork(singleSchoolSagaWatcher),
    fork(updateStoreSagaWatcher),
    fork(userStoresSagaWatcher),
    fork(userSchoolIdsSagaWatcher),
    fork(storesSaga),
    fork(asyncSyncWatcher),
    fork(checkPendingSyncsWatcher),
    fork(updateLevelMappingsSagaWatcher),
    fork(usersSagaWatcher),
    fork(privacyStatementSagaWatcher),
    fork(termsStatementSagaWatcher),
    fork(adminVendorsSagaWatcher),
    fork(vendorCategoriesSagaWatcher),
    fork(performVendorActionSagaWatcher),
    fork(createVendorSagaWatcher),
    fork(currentAdminVendorSagaWatcher),
    fork(editVendorSagaWatcher),
    fork(pendingAdminVendorsSagaWatcher),
    fork(vendorsImportsSagaWatcher),
    fork(importVendorCsvFileSagaWatcher),
    fork(downloadVendorCsvTemplateSagaWatcher),
    fork(requestCurrentVendorsImportSagaWatcher),
    fork(requestVendorsImportRecordsSagaWatcher),
    fork(vendorsForCsvTemplateSagaWatcher),
    fork(purchaseOtherCostsSagaWatcher),
    fork(allApprovedVendorsSagaWatcher),
    fork(commoditySourcesForSchoolSagaWatcher),
    fork(commoditySourcesForUserSagaWatcher),
    fork(allCommoditySourcesSagaWatcher),
    fork(foodSourcesSagaWatcher),
    fork(noMealReasonsSagaWatcher),
    fork(featureFlagsSagaWatcher),
    fork(downloadDatasetSagaWatcher),
    fork(downloadDatasetsSagaWatcher),
    fork(detailedStockDataSagaWatcher),
    fork(storeDoctorDataSagaWatcher),
    fork(stockMigrationSagaWatcher),
    fork(storeDoctorExportSagaWatcher),
    fork(eventsExportSagaWatcher),
    fork(stockInspectSagaWatcher),
    fork(stockSiblingsSagaWatcher),
    fork(mvRefreshLogSagaWatcher),
    fork(batchHealSagaWatcher),
    fork(xraySagaWatcher),
    fork(needsReviewListSagaWatcher),
    fork(needsReviewResolveSagaWatcher),
    fork(needsReviewCountSagaWatcher),
    fork(needsReviewImpactSagaWatcher),
    fork(needsReviewApplySagaWatcher),
  ]);
}
